module.exports = __webpack_public_path__ + "fonts/ProximaNova-Light.33a91e53.ttf";